import { motion } from "framer-motion";
import { Button } from "./ui/button";
import { LucideIcon, ArrowRight } from "lucide-react";

interface ServiceCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  buttonText: string;
  onClick: () => void;
}

export function ServiceCard({ icon: Icon, title, description, buttonText, onClick }: ServiceCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="group bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-[#d4a574]/30 relative overflow-hidden"
    >
      <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-[#d4a574]/5 to-transparent rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-transform duration-500"></div>
      
      <div className="flex flex-col items-center text-center space-y-4 relative z-10">
        <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-[#f9f1e8] to-[#faf8f5] flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-md">
          <Icon className="w-10 h-10 text-[#d4a574]" />
        </div>
        <h3 className="text-[#2c2c2c] group-hover:text-[#d4a574] transition-colors">{title}</h3>
        <p className="text-[#666] leading-relaxed">{description}</p>
        <Button
          onClick={onClick}
          className="mt-4 bg-gradient-to-r from-[#d4a574] to-[#c89464] hover:from-[#c89464] hover:to-[#b8845a] text-white rounded-full px-8 py-6 transition-all duration-300 shadow-lg shadow-[#d4a574]/30 group/btn"
        >
          {buttonText}
          <ArrowRight className="w-4 h-4 ml-2 group-hover/btn:translate-x-1 transition-transform" />
        </Button>
      </div>
    </motion.div>
  );
}
